"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Input = _interopRequireDefault(require("./Input")); // eslint-disable-next-line react/prop-types


var control = function control(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      innerRef = _ref.innerRef,
      children = _ref.children,
      isDisabled = _ref.isDisabled;
  return _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    fullWidth: true,
    InputProps: {
      disabled: isDisabled,
      disableUnderline: true,
      inputComponent: _Input["default"],
      inputProps: (0, _objectSpread2["default"])({}, innerProps, {
        children: children,
        className: selectProps.classes.multiInput,
        inputRef: innerRef
      })
    },
    FormHelperTextProps: {
      style: {
        marginTop: 4
      }
    }
  }, selectProps.textFieldProps));
};

var _default = control;
exports["default"] = _default;